var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "#333333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68162 4.71076L7.80041 1.29557C7.90616 1.17945 7.97309 1.03875 7.99343 0.889819C8.01377 0.740885 7.98668 0.589822 7.91531 0.454168C7.84394 0.318515 7.73122 0.203835 7.59022 0.123444C7.44923 0.0430532 7.28576 0.000248451 7.11879 0H0.881214C0.714238 0.000248451 0.550766 0.0430532 0.409776 0.123444C0.268786 0.203835 0.156063 0.318515 0.084693 0.454168C0.0133232 0.589822 -0.0137656 0.740885 0.00657257 0.889819C0.0269107 1.03875 0.0938411 1.17945 0.199593 1.29557L3.31838 4.71076C3.40119 4.8012 3.50525 4.87404 3.6231 4.92405C3.74096 4.97406 3.86967 5 4 5C4.13033 5 4.25905 4.97406 4.3769 4.92405C4.49475 4.87404 4.59882 4.8012 4.68162 4.71076Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.b9a25e1ddb6b991ce566699517488571.svg";
export { ForwardRef as ReactComponent };